import {round} from 'lodash-es';
// 判断系统类型
export function isMac() {
    const mac = /macintosh|mac os x/i.test(navigator.userAgent);
    if (mac) {
        return true;
    }
    return false;
}

export function getPageParams() {
    const path = window.location.pathname;
    const docReg = new RegExp('/knowledge/.+/.+/.+/.+');
    const repoReg = new RegExp('/knowledge/.+/.+/.+');
    const depReg = new RegExp('/department/.+/.+');
    if (docReg.test(path)) {
        const paramArr = path.replace('/knowledge/', '').split('/');
        return {
            spaceGuid: paramArr[0],
            groupGuid: paramArr[1],
            repositoryGuid: paramArr[2],
            docGuid: paramArr[3],
        };
    } else if (repoReg.test(path)) {
        const paramArr = path.replace('/knowledge/', '').split('/');
        return {
            spaceGuid: paramArr[0],
            groupGuid: paramArr[1],
            repositoryGuid: paramArr[2],
        };
    } else if (depReg.test(path)) {
        const paramArr = path.replace('/department/', '').split('/');
        return {
            spaceGuid: paramArr[0],
            groupGuid: paramArr[1],
        };
    }
    return null;
}

export function filterEmoji(text: string, replaceText: string) {
    // eslint-disable-next-line max-len
    const regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|\uA9|\uAE|\u3030/ig;
    return text.replace(regStr, replaceText);
}

/**
 * 复制文字到剪贴板
 * @param text 复制内容
 */
export function copyText(text: string) {
    if (navigator.clipboard && !/Infoflow\/Windows|minihi/.test(navigator.userAgent)) {
        // clipboard api 复制，如流windows客户端内navigator.clipboard暂无权限
        navigator.clipboard.writeText(text);
    } else {
        // 兼容不支持新 API 的场景
        const textarea = document.createElement('textarea');
        document.body.appendChild(textarea);
        // 隐藏此输入框
        textarea.style.position = 'fixed';
        textarea.style.clip = 'rect(0 0 0 0)';
        textarea.style.top = '10px';
        // 赋值
        textarea.value = text;
        // 选中
        textarea.select();
        // 复制
        document.execCommand('copy', true);
        // 移除输入框
        document.body.removeChild(textarea);
    }
}

/**
 * 复制到剪贴板
 */
export function copyToClipboard(contents: {
    'text/plain'?: string;
    'text/html'?: string;
}) {
    return new Promise<void>((resolve) => {
        const divEl = document.createElement('div');
        divEl.innerText = 'content';
        divEl.style.width = '0';
        divEl.style.height = '0';
        divEl.style.overflow = 'hidden';
        divEl.addEventListener('copy', (e) => {
            e.preventDefault();
            if (e.clipboardData) {
                e.clipboardData.clearData();
                Object.entries(contents).forEach(([key, value]) => {
                    value && e.clipboardData?.setData(key, value);
                });
                document.body.removeChild(divEl);
                resolve();
            }
        });

        document.body.appendChild(divEl);
        const range = document.createRange();
        range.selectNodeContents(divEl);
        const selection = window.getSelection();
        selection?.removeAllRanges();
        selection?.addRange(range);
        document.execCommand('copy');
    });
}

export const transformNumberToW = (num: number) => {
    if (num >= 10000) {
        return `${round(num / 10000, 1)}w`;
    }
    return num;
};

export const transformNumberToK = (val: string | number) => {
    const num = Number(val);
    if (num >= 1000) {
        return `${round(num / 1000, 1)}k`;
    }
    return num;
};
interface IObject {
    [key: string]: string | IObject;
}

/**
 * @param obj 需要进行判断的对象
 * @param key 需要判断的key
 * @returns boolean
 * @description  判断可能无限嵌套的对象里是否存在某个key
 */
export function hasKey(obj: IObject | string, key: string): boolean {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }

    // 如果有 且value是个字符串 -> 那么返回true
    if (key in obj && typeof obj[key] === 'string') {
        return true;
    }

    for (const k in obj) {
        if (hasKey(obj[k], key)) {
            return true;
        }
    }

    return false;
}

//  秒数转化为时分秒
export function secondsToHHMMSS(seconds: number) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}
